import type { IssueViewFetchOperations } from '../../types.tsx';

export const appendOperationQuery = (operation?: IssueViewFetchOperations | string): string =>
	operation ? `?operation=${operation}` : '';
